// Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import Button from "./Button";

export default function Footer() {
  return (
    <footer className="bg-base text-body border-t border-border py-8 px-4 text-sm mt-10">
      <div className="max-w-4xl mx-auto space-y-6">
        {/* Textul centrat de Corina */}
        <div className="text-center italic">
          Fii cu celălalt așa cum e azi. Fii cu tine așa cum ești acum. Cu prezență, Corina
        </div>

        {/* Restul conținutului */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">
          <p>&copy; {new Date().getFullYear()} - Trăiește-ți Designul. Toate drepturile rezervate.</p>
          <div className="flex gap-4">
            <Link to="/termeni" className="hover:underline">
              Termeni & condiții
            </Link>
            <Link to="/contact" className="hover:underline">
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
